import { API } from '~apis/axios/instance';
import { AuthModel } from '~models/auth';
import { ResponseBase } from '~types/response';

interface Response extends ResponseBase {
  data: {
    accessToken: string;
  };
}

/**
 * 회원가입
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/user-sign-controller/signupWithNewCompany
 * @param payload
 * @returns
 */
export default function postUser(payload: AuthModel.SignUpRequest) {
  return API.post<Response>('/api/v3/users', { data: { ...payload } });
}
